import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/Card';
import { ShopTagForm } from '@/features/phase2/ShopTagForm';

export const Route = createFileRoute('/_authed/phase2/shop-tags')({
  component: ShopTagsScreen,
});

function ShopTagsScreen() {
  const { t } = useTranslation('phase2');
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('shopTags.title', { defaultValue: 'Shop tags' })}
        </h1>
        <p className="max-w-2xl text-sm text-[color:var(--color-fg-muted)]">
          {t('shopTags.subtitle', {
            defaultValue:
              'Link any editorial subject to marketplace inventory ("Shop My Look"). Idempotent on (subject, product, variant) — re-saving updates the position.',
          })}
        </p>
      </header>

      <Card>
        <CardContent className="pt-6">
          <p className="mb-4 text-xs text-[color:var(--color-fg-muted)]">
            {t('shopTags.openQuestion', {
              defaultValue:
                "No list endpoint is documented yet — operators tag here and the consumer client reads via /v1/shop-tags/{kind}/{id}. We'll wire a list once exposed.",
            })}
          </p>
          <ShopTagForm />
        </CardContent>
      </Card>
    </div>
  );
}
